module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-6.2353de8e.JPG";